export default __webpack_public_path__ + "static/Jar_of_Pitch-6114c89d7342bc25cbef999119372c36.png";